/**
 * Oturum öncesi ekranlarda kullanılan çizgi ikonlar.
 *
 * Emoji yerine SVG kullanılır: emoji her işletim sisteminde farklı çiziliyor
 * ve şifre göster/gizle gibi durum bildiren yerlerde açık/kapalı ayrımı
 * anlaşılmıyordu.
 */

const temel = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export function IkonGoz({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...temel}>
      <path d="M1.5 12S5 5.5 12 5.5 22.5 12 22.5 12 19 18.5 12 18.5 1.5 12 1.5 12z" />
      <circle cx="12" cy="12" r="3.2" />
    </svg>
  );
}

export function IkonGozKapali({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...temel}>
      <path d="M9.9 5.7A9.9 9.9 0 0112 5.5c7 0 10.5 6.5 10.5 6.5a18 18 0 01-3.2 4.1" />
      <path d="M6.5 7.4A17.7 17.7 0 001.5 12S5 18.5 12 18.5c1.6 0 3-.3 4.2-.9" />
      <path d="M9.9 9.9a3.2 3.2 0 004.3 4.3" />
      <line x1="3" y1="3" x2="21" y2="21" />
    </svg>
  );
}

export function IkonKilit({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...temel}>
      <rect x="4" y="10.5" width="16" height="10" rx="2.5" />
      <path d="M8 10.5V7.5a4 4 0 018 0v3" />
      <circle cx="12" cy="15.5" r="1.2" />
    </svg>
  );
}

export function IkonKalkan({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...temel}>
      <path d="M12 2.8l7.5 3v6c0 4.6-3.1 8.4-7.5 9.4-4.4-1-7.5-4.8-7.5-9.4v-6l7.5-3z" />
      <line x1="9" y1="12" x2="15" y2="12" />
    </svg>
  );
}

export function IkonPusula({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...temel}>
      <circle cx="12" cy="12" r="9.2" />
      <path d="M15.5 8.5l-1.8 5.2-5.2 1.8 1.8-5.2 5.2-1.8z" />
    </svg>
  );
}

export function IkonUyari({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...temel}>
      <path d="M12 3.6l9 15.6H3l9-15.6z" />
      <line x1="12" y1="9.5" x2="12" y2="14" />
      <circle cx="12" cy="16.6" r="0.9" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function IkonSaat({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...temel}>
      <circle cx="12" cy="12" r="9.2" />
      <path d="M12 6.8V12l3.4 2.2" />
    </svg>
  );
}

export function IkonZarf({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...temel}>
      <rect x="3" y="5.5" width="18" height="13" rx="2" />
      <path d="M3.5 7l8.5 5.8L20.5 7" />
    </svg>
  );
}
